import React from 'react';
import { CircularProgress } from '@mui/material';
import styled from 'styled-components/macro';

export const LoginPageLayout = props => {
  return (
    <Wrapper>
      <CircularProgress size='50px' className='loging-icon'/>
      {props.children}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  
  .loging-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(50%, -50%);
  }
`;